'use strict';

var React = require('react');

var SvgMetafieldsMajor = function SvgMetafieldsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 2.5a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5v.5h2v-.5a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5v.768a2 2 0 0 1 1 1.732v5h-18v-5a2 2 0 0 1 1-1.732v-.768Zm-1 9.5h18v5a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2v-5Z"
  }));
};

exports.SvgMetafieldsMajor = SvgMetafieldsMajor;
